import customerServiceQA from '@/locales/en/customerServiceQA/customerServiceQA.locales';

export default {
    ...customerServiceQA,
};
